export default "__VITE_ASSET__CYoDvpgC__"